
import Vue from 'vue'
import SlotsHead from '../headers/SlotsHead.vue'
import CustomHead from '../headers/CustomHead.vue'
import router from '@/router'
import { mapActions } from 'vuex'

export default Vue.extend({
  name: 'cardmixin',
  data() {
    return { scrolllY: 0 }
  },
  components: {
    SlotsHead,
    CustomHead
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions({
      generateRoutes: 'permission/generateRoutes'
    }),
    checkScrollY(name, length) {
      const dev = document.getElementById(name + this.id)
      if (dev && length * 33 > dev.clientHeight - 34) {
        this.scrolllY = dev.clientHeight - 34
      } else {
        this.scrolllY = 0
      }
    },
    saveNameEdit(value, item) {
      this.$emit('saveNameEdit', value, item)
    },
    deleteItem() {
      this.$emit('deleteItem', this.item)
    },
    ViewMOre(key, query) {
      switch (key) {
        case 'work-record':
          this.goRouter('ops', '运维系统', '/ops/work-record-list')
          break
        case 'pending-work-all':
          this.goRouter('ops', '运维系统', '/ops/work-record-list')
          break
        case 'pending-work':
          this.goRouter('ops', '运维系统', '/ops/work-record-list', query)
          break
        case 'record-history':
          this.goRouter('ops', '运维系统', '/ops/work-record-history', query);
          break;
        case 'threshold-rate-table-all':
          this.goRouter('mdc', '设备分析', '/mdc/equipment-utilization-rate')
          break
        case 'screening-customers-table':
          this.goRouter('ops', '运维系统', '/ops/customer', query)
          break
        case 'threshold-rate-table': 
          this.goRouter('ops', '运维系统', '/ops/customer', query);
          break;
        case 'go-machine':
          this.goRouter('ops', '运维系统', '/ops/machine', query);
          break;
      }
    },
    async goRouter(appCode, appName, link, query) {
      const data = await this.generateRoutes(appCode) // 动态增加路由
      this.$store.commit('permission/SET_ROUTES', data)
      this.$store.commit('permission/SET_APP_ROUTE_MAP', {
        appCode: appCode,
        appName: appName,
        routes: data.length ? data[0].children : []
      })
      router.addRoutes(
        data.concat({
          path: '*',
          redirect: '/404'
        })
      )
      this.$router.push({ path: link, query })
    }
  }
})
